// extracted by mini-css-extract-plugin
export default {"searchBox":"Search_searchBox__36pr7","inputSearch":"Search_inputSearch__Kf7uK"};